import { Component, OnInit, Input, ViewChild, ElementRef, ChangeDetectorRef, HostListener, EventEmitter } from '@angular/core';
import { GeneralService } from '../../_provider/general.service';
import { Subscription } from 'rxjs';
import { DarkmodeService } from '../../_provider/darkmode.service';
import { AFSInputType, FeedbackService, MsgType } from '../../_provider/feedback.service';
import { ResizeManagerService, ScreenSize } from '../../_provider/resize-manager.service';
import {  ItemReorderEventDetail, ModalController, NavController, Platform } from '@ionic/angular';
import { HttpFunctionResult } from '../../_interfaces/HttpFunctionResult';
import { TicketEmployee } from '../../_provider/tickets/ticket.service';
import { WorkstepBase } from '../../_interfaces/workstep';
import { PopoverListItem, PopoverPage } from '../popover/popover.page';
import { TicketEditService } from '../../_provider/ticket-edit.service';
import { EditArt } from '../../_interfaces/EditArt';
import { ContentEditPopupPage } from './content-edit-popup/content-edit-popup.page';
import { ITicketState } from '../../_interfaces/TicketState';
import { SaveService } from '../../_provider/save.service';
import { ZeitenService } from '../../_provider/zeiten.service';
import { TicketArtSelectPage } from '../ticket-more/ticket-detail-allgemein/ticket-art-select/ticket-art-select.page';
import { Task } from 'src/app/_interfaces/Task';
import { MultipleContentPage } from './multiple-content/multiple-content.page';
import { WorkstepContent } from './workstep-content/workstep-content.component';
import { TimeOverviewBasePage } from '../time-overview/time-overview-base/time-overview-base.page';
import { TicketZeit } from 'src/app/_interfaces/TicketTime';
import { SignPreviewPage } from 'src/app/_pages/sign/sign-preview/sign-preview.page';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';
import { TaskTemplateBase, TaskTemplateItem, TaskTemplateOverviewPage } from 'src/app/_pages/new-settings/ticket-settings/task-template-overview/task-template-overview.page';
import { EmailService } from 'src/app/_provider/email.service';
import { TicketStateColor } from 'src/app/_pipes/TicketState.pipe';

@Component({
    selector: 'app-ticket-detail',
    templateUrl: './ticket-detail.component.html',
    styleUrls: ['./ticket-detail.component.scss'],
    standalone: false
})
export class TicketDetailComponent implements OnInit {

  @ViewChild('ticketDetail', {static: false}) ticketDetail: ElementRef; 
  @ViewChild('taskAddInput', {static: false}) taskAddInput: ElementRef; 

  //optional -> kann bei model aufrufen der DetailPage in ComponentProps übergeben werden
  @Input() modelWorkstepId: number = 0
  @Input() isPage: boolean = false
  @Input() highlightedContentId: number = 0

  public isDarkmode: boolean
  public isMoreOpen: boolean = true
  public openMoreSegmentValue: string = "overview"
  public _contentSegementValue: string = "messages"
  
  private screenSizeSub: Subscription

  public get contentSegementValue(): string{
    if(!this.general.webConfig?.show_ticket_tasks) return "messages"
    return this._contentSegementValue
  }
  public set contentSegementValue(value: string){
    this._contentSegementValue = value
  }


  public searchValue: string = ""
  public taskAddText: string = ""

  public isStateLoading: boolean = false
  

  public contentOnEditID: number = -1

  //Für drag and drop von Bildern
  @HostListener('dragenter', ["$event"]) async onDrop(evt){this.onParentDrop.emit(evt)}
  public onParentDrop: EventEmitter<any> = new EventEmitter<any>(null)

  constructor(
    public general: GeneralService, 
    private darkmode: DarkmodeService,
    private feedback: FeedbackService,
    private navCtrl: NavController,
    public ticketSrv: TicketEmployee.TicketService,
    private changeDetector: ChangeDetectorRef,
    private modalCtrl: ModalController,
    public resizeManager: ResizeManagerService,
    private ticketEditSrv: TicketEditService,
    private saveSrv: SaveService.Ticket,
    private saveSrvSettings: SaveService.Settings,
    private timeSrv: ZeitenService,
    private hotkeySrv: HotkeysService,
    private emailSrv: EmailService,
    public platform: Platform,
    ) {
      //Shortcut für neuen content hinzufügen
      this.hotkeySrv.add(new Hotkey(["meta+m", "ctrl+m"], (event: KeyboardEvent): boolean=>{
        if(!this.ticketSrv?.ticket) return true
        this.addWorkstepContent()
        return false 
      }))

      //darkmode hat sich geändert...
      this.darkmode.isDarkMode.subscribe((result: boolean)=> this.isDarkmode = result)
  }

  ngOnInit() {
    this.ticketSrv.clearWorkstepContentList()
    this.screenSizeSub = this.resizeManager.screenSizeChanged.subscribe((size: ScreenSize) => {
      if(this.resizeManager.isWeb && !this.isPage) this.openMoreSegmentValue = "settings"
      else this.openMoreSegmentValue = "overview"
     })
  }

  public async addWorkstepContent(isMail: boolean = false, contentId: number = -1){
    if(this.ticketSrv.hasWorkstepContentEditValue) return
    await this.startTicketTimeForWorkstep()
    this.emailSrv.contentId = contentId
    if(this.isPage || this.resizeManager.screenSize == ScreenSize.TabletLandscape) await this.feedback.openModal(ContentEditPopupPage, {content: null, isNew: true, isModal: true, isMail: isMail}, ()=>{}, false)
    else{
      const workingEmailContent: WorkstepContent = this.ticketSrv.workstepContentsOnEdit.find(s => s.isMail)
      if(workingEmailContent){
        const mailOpenResult: boolean = await this.feedback.confirm(`Sie sind gerade dabei eine E-Mail in "${workingEmailContent?.mailDescription}" zu erstellen. Möchten Sie diese verwerfen?`,"Abbrechen", "E-Mail verwerfen")
        if(!mailOpenResult)this.ticketSrv.workstepContentsOnEdit = this.ticketSrv.workstepContentsOnEdit.filter(s => !s.isMail)
        else return
      }
      
      this.contentOnEditID = -1
      this.ticketSrv.workstepContentsOnEdit.push({
        id: null,
        isMail: isMail,
        isNew: true,
        mailDescription: this.ticketSrv.ticket.description,
        workstepId: this.ticketSrv.activeWorkstepId,
        htmlText: ""
      })
    }
  }

  public setContentSegmentValue(event: any){
    this.contentSegementValue = event.target.value
  }

  //SUBSCRIPTIONS AUFLÖSEN
  async ngOnDestroy(){
    this.ticketSrv.clearWorkstepContentList()
    this.screenSizeSub?.unsubscribe()
  }

  openMore(segmentValue: string){
      this.openMoreSegmentValue = segmentValue
      this.isMoreOpen = !this.isMoreOpen
  }

  public async openWorkSteps(ev: Event){
    await this.feedback.openPopover<EditArt>(PopoverPage,ev,{type: "Worksteps", activeWorkstep: this.ticketSrv.activeWorkstep.id},(result: HttpFunctionResult<EditArt>)=>{
      if(!result.success) return
      this.ticketSrv.activeWorkstep = this.ticketSrv.worksteps.find(w => w.id == result.data.id)
      this.selectWorkstep()
    })
  }

  private async selectWorkstep(){
    this.ticketSrv.isLoading = true
    await this.ticketSrv.setNewWorkstepAttributes(this.ticketSrv.activeWorkstep.id, this.timeSrv.getRunningTimeIdsByWorkstepId(this.ticketSrv.activeWorkstep.id))
    this.ticketSrv.isLoading = false
  }

  private async addWorkspace(){

    await this.feedback.openModal<EditArt>(TicketArtSelectPage, {type: "modal"}, async (res: HttpFunctionResult<EditArt>)=>{
      if(!res.success) return
      let workstepName = ""
      if(this.general.serverVersionGreaterThan("1.7.0")){

        const inputResult: HttpFunctionResult<string> = await this.feedback.showInput({
          header: "Bezeichnung",
          message: "Bitte geben Sie die Bezeichnung des Arbeitsschrittes an.",
          placeholder: "Bezeichnung...",
          type: AFSInputType.TEXT,
          autofocus: true
        })

        if(!inputResult.success) return

      }      
      const result: HttpFunctionResult<WorkstepBase> = await this.ticketSrv.createNewWorkstep(res.data, workstepName)
      if(result.success){
        this.ticketSrv.activeWorkstep = this.ticketSrv.worksteps.find(w => w.id == result.data.id)
        this.ticketEditSrv.addWorkStep(this.ticketSrv.activeWorkstep)
        this.selectWorkstep()
      }else{
        if(result.data) if(result.data.id == -31){
          await this.feedback.showMsg(MsgType.Info, "In der Demo-Version kann leider kein neuer Arbeitsschritt angelegt werden. Sie können jedoch in den existierenden Arbeitsschritten alles ausprobieren.🥸")
        }
      }
    })
  }

  private async changeWorkstepName(){

    const inputResult: HttpFunctionResult<string> = await this.feedback.showInput({
      header: "Neue Bezeichnung",
      message: "",
      placeholder: "Bezeichnung...",
      type: AFSInputType.TEXT,
      autofocus: true
    })

    if(!inputResult.success) return

    await this.feedback.updateLoading("Speichern...")
    const result : HttpFunctionResult<any> = await this.saveSrv.saveWorkstepName(inputResult.data)
    if(!result.success) return
    this.ticketSrv.activeWorkstep.description = inputResult.data
    await this.feedback.hideLoading()
  }

  private async createTicketReport(){
    // if(!(await this.feedback.confirm("Möchten Sie jetzt einen Ticketbericht erstellen?"))) return
    this.feedback.showModal({
      component: SignPreviewPage,
      backdropDismiss: true,
      cssClass: "modal-fullscreen",
    })
    // await this.feedback.openModal(SignPreviewPage, null, ()=>{}, true)
  }

  public segmentValueChanged(event: any){
    this.openMoreSegmentValue = event.target.value
  }


  private contentSearchTimeout:any
  public async searchWorkstepContent(){
    clearTimeout(this.contentSearchTimeout)
    this.contentSearchTimeout = setTimeout(async () => await this.ticketSrv.setWorkstepContent(this.ticketSrv.activeWorkstepId, this.searchValue), 300);
  }

  public async onWorkstepContentEdit(event: WorkstepContent){
    if(event === undefined) return
    if(event === null) this.contentOnEditID = -1
    else{
      if(this.isPage) await this.feedback.openModal(ContentEditPopupPage, {content: event,isNew: false, isModal: true}, ()=>{}, false)
      else{
        if(this.ticketSrv.hasWorkstepContentEditValue){
          if(!(await this.feedback.confirm("Sie sind gerade dabei einen neuen Eintrag zu erstellen. Möchten Sie diesen verwerfen?", "Verwerfen", "Abbrechen"))) return
          this.ticketSrv.workstepContentsOnEdit = this.ticketSrv.workstepContentsOnEdit.filter(s => s.workstepId != this.ticketSrv.activeWorkstepId)
        }
        this.contentOnEditID = event.id
      }
    }
  }

  public async workstepContentClosed(data: WorkstepContent ){
    if(data === undefined) return
    this.ticketSrv.workstepContentsOnEdit = this.ticketSrv.workstepContentsOnEdit.filter(s => s.workstepId != this.ticketSrv.activeWorkstepId)
  }

  /**
   * Zeit starten für aktuellen Arbeitsschritt wenn noch keine gestartet ist
   */
  private async startTicketTimeForWorkstep(task?:Task){
    if(this.timeSrv.isActiveTicket(this.ticketSrv.activeWorkstepId) == null || task){
      await this.feedback.updateLoading("Zeit starten...")
      await this.timeSrv.startTicketTime(this.ticketSrv.activeWorkstepId, this.ticketSrv.ticket, task)
      await this.feedback.hideLoading()
      const toastText: string = task ? "Die Zeit für die ausgewählte Tätigkeit wurde gestartet." : "Die Zeit für den ausgewählten Arbeitsschritt wurde gestartet."
      this.feedback.showInformationToast(toastText, "Zeit gestartet", 3000)
    }
  }

  public async openWorkstepSelect(event: Event){
    await this.feedback.openPopover<EditArt>(PopoverPage, event, {type: "WorkstepSelect"}, async (result: HttpFunctionResult<EditArt>)=>{
      if(!result.success) return

      switch (result.data.id) {
        case 1:
          await this.addWorkspace()
          break;
        case 2:
          await this.changeWorkstepName()
          break;
        case 3:
          await this.createTicketReport()
          break;
        case 5:
          window.location.href = `afsts:ShowTicket:${this.ticketSrv.ticket.id}`
          break;
        case 6:
          this.ticketSrv.openInNewTab()
          break
        case 7:
          this.changeTicketName()
          break;
        default:
          await this.ticketSrv.copyTicketLinkToClipboard()
          await this.feedback.showInformationToast("Link zum Ticket wurde in die Zwischenablage kopiert.")
          break;
      }
    })
  }

  public async changeTicketName(){

    const inputResult: HttpFunctionResult<string> = await this.feedback.showInput({
      header: "Neue Bezeichnung",
      message: "",
      initialText: this.ticketSrv.ticket.description,
      placeholder: "Bezeichnung...",
      type: AFSInputType.TEXT,
      autofocus: true
    })

    if(!inputResult.success) return

    await this.feedback.updateLoading("Speichern...")
    const result : HttpFunctionResult<any> = await this.saveSrv.saveTicketName(inputResult.data)
    if(!result.success) return
    this.ticketSrv.ticket.description = inputResult.data
    await this.feedback.hideLoading()
  }

  public async showTicketStates(event: Event){

    const list: PopoverListItem[] = this.ticketEditSrv.ticketStates.map(state => {
      return {
        id: state.id,
        description: state.description,
        stateColor: TicketStateColor.getColor(state.id, this.ticketEditSrv.ticketStates)
      }
    })

    await this.feedback.openPopover<ITicketState>(
      PopoverPage, 
      event,
      {list},
      async (result: HttpFunctionResult<ITicketState>)=>{
        if(!result.success) return
        this.isStateLoading = true
        this.ticketSrv.ticket.state = result.data.id
        this.ticketSrv.ticket.isClosed = this.ticketEditSrv.ticketStates.find(tS=>tS.id == result.data.id).closed 
        await this.saveSrv.saveTicketState(result.data)
        this.isStateLoading = false
      }      
    )
  }

  //#region [Main] Tasks

  public async checkTask(task: Task){
    task.checked = !task.checked
    if(this.isTaskTimeActive(task.id) && task.checked){
      if(!(await this.feedback.confirm("Möchten Sie die Zeit stoppen?"))) return
      await this.timeSrv.stopTicketTime(this.timeSrv.timeTickett.find(tt => tt.taskId == task.id).time)
    }
    await this.ticketSrv.updateTask(task)
  }

  public async openTaskOptions(event: any, task: Task){

    event.stopPropagation()

    await this.feedback.openPopover<EditArt>(PopoverPage, event, {
      type: "TaskMenu",
      replaceArt: this.isTaskTimeActive(task.id) ? {id: 3, description: "Zeit stoppen", icon: "fa-sqaure"} as PopoverListItem : null
    }, async (result: HttpFunctionResult<EditArt>)=>{
      if(!result.success) return

      //1 = Inhalt zeigen
      //2 = Bezeichnung ändern 
      //3 = Zeit starten/stoppen
      //4 = löschen
      switch (result.data.id) {
        case 1:
          await this.feedback.updateLoading("Laden...")
          const contentResult: HttpFunctionResult<WorkstepContent[]> = await this.ticketSrv.getContentByTask(task.id)
          await this.feedback.hideLoading()
          if(!contentResult.success) return
          await this.feedback.openModal<any>(MultipleContentPage, {content: contentResult.data, taskId: task.id})
          break;
        case 2:

          const inputResult: HttpFunctionResult<string> = await this.feedback.showInput({
            header: "Neue Bezeichnung",
            message: "Bitte geben Sie eine neue Bezeichnung ein.",
            placeholder: "Bezeichnung...",
            type: AFSInputType.TEXT,
            autofocus: true
          })
          
          if(!inputResult.success) return

          task.description = inputResult.data
          await this.ticketSrv.updateTask(task)
          break;
        case 3:
          if(!this.isTaskTimeActive(task.id)) await this.startTicketTimeForWorkstep(task)
          else{
             let time: TicketZeit = this.timeSrv.timeTickett.find(tt => tt.taskId == task.id).time;
             time.taskId = task.id
            await this.timeSrv.stopTicketTime(time)
          }
          break;
        default:
          if(!(await this.feedback.confirm("Möchten Sie diese Tätigkeit wirklich löschen?", "Löschen", "Abbrechen"))) return
          if(this.isTaskTimeActive(task.id)) await this.timeSrv.stopTicketTime(this.timeSrv.timeTickett.find(tt => tt.taskId == task.id).time)
          this.ticketSrv.tasks.splice(this.ticketSrv.tasks.indexOf(task), 1)
          await this.ticketSrv.deleteTask(task.id)
          break;
      }
    })
  }

  async handleTaskReorder(ev: CustomEvent<ItemReorderEventDetail>) {
    ev.detail.complete(this.ticketSrv.tasks);
    await this.ticketSrv.reorderTasks(this.ticketSrv.tasks.map((t, index) => ({key: t.id, value: index})))
  }

  /**
   * Fügt eine neue Tätigkeit zum Arbeitsschritt hinzu
   * @param event Keyboardevent um abzugragen ob Ctrl oder Command gedrückt wurde bei Enter (optionaler Paramater) 
   * @returns 
   */
  public async addNewTask(event?: any){

    if(event == undefined || event?.key == "Enter"){
      const maxOrderNumber = Math.max.apply(Math, this.ticketSrv.tasks.map(o => o.orderNumber )) || 0
  
      if(!this.taskAddText) return
  
      let task: Task = {
        description: this.taskAddText,
        orderNumber: maxOrderNumber == -Infinity ? 1 : maxOrderNumber + 1,
        checked: false
      }
  
      await this.feedback.updateLoading("Anlegen...")
      const response: HttpFunctionResult<Task> = await this.ticketSrv.addTask(task)
      await this.feedback.hideLoading()
      if(!response.success) return
      task.id = response.data.id

      //Zeit nur starten wenn nicht Command und Ctrl gedrückt wurde bei Enter
      if((!event?.metaKey && !event?.ctrlKey))await this.startTicketTimeForWorkstep(task)
      if((event?.metaKey || event?.ctrlKey)) this.taskAddInput.nativeElement.focus()

      this.taskAddText = ""
      this.ticketSrv.tasks.push(response.data)
    }
  }

  public getCompleteTasksCount(): number{
    return this.ticketSrv.tasks.filter(t => t.checked).length
  }

  public isTaskTimeActive(id: number): boolean{
    return this.timeSrv.timeTickett.find(tt => tt.taskId == id) ? true : false
  }

  public async openTimeByTask(event: any, id: number){
    event.stopPropagation()

    const modal = await this.modalCtrl.create({
      component: TimeOverviewBasePage,
      keyboardClose: true,
      // swipeToClose: false,
      componentProps: {taskId: id}
    })
    await modal.present()
  }


  public async openTaskPopover(event: any){
    await this.feedback.openPopover(PopoverPage, event, {type: "taskOptions"}, async (result: HttpFunctionResult<PopoverListItem>)=>{
      if(!result.success) return

      //1 = Vorlage importieren
      //2 = Vorlage erstellen
      if(result.data.id == 1){
        this.feedback.openModal(TaskTemplateOverviewPage, {toSelect: true}, async (result: HttpFunctionResult<TaskTemplateBase>)=>{
          if(!result.success) return
          await this.feedback.updateLoading("Laden...")
          const tasksResult: HttpFunctionResult<TaskTemplateItem[]> = await (this.ticketSrv as TicketEmployee.TicketService).getTasksByTemplate(result.data.id)
          if(tasksResult.success){
            const createdTasksResult: HttpFunctionResult<Task>[] = await Promise.all(tasksResult.data.map(t =>{
              return (this.ticketSrv as TicketEmployee.TicketService).addTask({
                description: t.description,
                orderNumber: t.sort
              })
            }))
            this.ticketSrv.tasks = [...this.ticketSrv.tasks, ...createdTasksResult.map(ctr => {
              if(ctr.success) return ctr.data
            })].sort((a, b) => a.orderNumber > b.orderNumber ? 1 : a.orderNumber === b.orderNumber ? 0 : -1);
          }
          await this.feedback.hideLoading()
        })
      }else if(result.data.id == 2){
        if(this.ticketSrv.tasks.length == 0) return await this.feedback.showError("Bevor Sie eine Vorlage erstellen, müssen Sie Tätigkeiten hinzufügen.")

         const inputResult: HttpFunctionResult<string> = await this.feedback.showInput({
          header: "Bezeichnung",
          message: "Bezeichnung der Vorlage",
          placeholder: "Mustervorlage...",
          type: AFSInputType.TEXT,
          autofocus: true
        })

        if(!inputResult.success) return

        await this.feedback.updateLoading("Speichern...")
        const createTemplateResponse: HttpFunctionResult<TaskTemplateBase> = await this.saveSrvSettings.createTaskTemplate({description: inputResult.data})
        if(!createTemplateResponse.success) return await this.feedback.hideLoading()
        const createTasksResponse: HttpFunctionResult<any> = await this.saveSrvSettings.createOrUpdateTaskTemplateItems(this.ticketSrv.tasks.map(t =>{
          return {
            description: t.description,
            sort: t.orderNumber,
            templateId: createTemplateResponse.data.id
          }
        }), createTemplateResponse.data.id)
        await this.feedback.hideLoading()
        await this.feedback.showInformationToast("Die Vorlage wurde Erfolgreich erstellt!", "Erfolgreich")

      }
    })
  }

    //#endregion

    public async onScroll(event: any){
      // if(this.isPage && this.contentSegementValue == "messages" && (this.mediaSizeMobile && this.openMoreSegmentValue == "overview")){
      //   if(this.ticketSrv.workstepCanMoreLoad){
      //     this.ticketSrv.contentOffset+=25
      //     await this.ticketSrv.setWorkstepContent(this.ticketSrv.activeWorkstepId, this.searchValue)
      //   }
      //   setTimeout(() => (event).target.complete(), 500);
      // }

      // if(!this.ticketSrv.workstepCanMoreLoad || this.contentSegementValue != "messages" || this.isPage || (this.mediaSizeMobile && this.openMoreSegmentValue != "overview")) return

      // const element = this.scrollableDiv;
      // const atBottom = element.scrollHeight - Math.round(element.scrollTop) <= element.clientHeight;
      // if (atBottom) {
      //   this.ticketSrv.contentOffset+=25
      //   await this.ticketSrv.setWorkstepContent(this.ticketSrv.activeWorkstepId, this.searchValue)
      // }
    }

    get scrollableDiv() {
      return document.querySelector('#ticket-detail');
    }

  

}
